(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mk-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMkSwiper(container) {
      if (container.getAttribute('data-mk-swiper-inited') === 'true') {
        return;
      }

      var wrapper = container.querySelector('.swiper-wrapper');
      if (!wrapper) {
        return;
      }

      var slides = Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide'));
      if (!slides.length) {
        return;
      }

      var transition = container.getAttribute('data-transition') || 'slide';
      var useFade = container.getAttribute('data-fade') === 'true' || transition === 'fade';
      var autoplayValue = container.getAttribute('data-autoplay');
      var autoplayDelay = parseInt(autoplayValue || '0', 10);
      var pagination = container.querySelector('.swiper-pagination');
      var prevBtn =
        container.querySelector('.swiper-button-prev') || container.querySelector('.flickity-nav.flickity-prev');
      var nextBtn =
        container.querySelector('.swiper-button-next') || container.querySelector('.flickity-nav.flickity-next');
      var fractionCurrent =
        container.querySelector('.swiper-fraction-current') ||
        container.querySelector('.flickity-custom-navigation--current');
      var fractionTotal =
        container.querySelector('.swiper-fraction-total') ||
        container.querySelector('.flickity-custom-navigation--total');
      var current = 0;
      var timer = null;

      function updateTransforms() {
        if (useFade) {
          return;
        }
        var offset = -current * 100;
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.transform = 'translateX(' + offset + '%)';
        }
      }

      function setActive(index) {
        if (index < 0) {
          index = slides.length - 1;
        } else if (index >= slides.length) {
          index = 0;
        }
        current = index;

        for (var i = 0; i < slides.length; i++) {
          if (i === current) {
            slides[i].classList.add('is-active');
          } else {
            slides[i].classList.remove('is-active');
          }
        }

        if (!useFade) {
          updateTransforms();
        }

        if (pagination) {
          var bullets = Array.prototype.slice.call(pagination.children);
          for (var j = 0; j < bullets.length; j++) {
            if (j === current) {
              bullets[j].classList.add('is-active');
            } else {
              bullets[j].classList.remove('is-active');
            }
          }
        }

        if (fractionCurrent) {
          fractionCurrent.textContent = String(current + 1);
        }

        updateHeight();
      }

      function updateHeight() {
        if (container.classList.contains('desktop-height-full') || container.classList.contains('mobile-height-full')) {
          wrapper.style.height = '';
          return;
        }

        var activeSlide = slides[current];
        if (!activeSlide) {
          return;
        }

        var slideHeight = activeSlide.offsetHeight;
        if (!slideHeight) {
          return;
        }

        wrapper.style.height = slideHeight + 'px';
      }

      if (pagination) {
        pagination.innerHTML = '';
        for (var i = 0; i < slides.length; i++) {
          var bullet = document.createElement('button');
          bullet.type = 'button';
          bullet.className = 'swiper-pagination-bullet';
          bullet.setAttribute('aria-label', String(i + 1));
          (function (index) {
            bullet.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              setActive(index);
              restartAutoplay();
            });
          })(i);
          pagination.appendChild(bullet);
        }
      }

      if (fractionTotal) {
        fractionTotal.textContent = String(slides.length);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActive(current - 1);
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActive(current + 1);
          restartAutoplay();
        });
      }

      function restartAutoplay() {
        if (!autoplayDelay || autoplayDelay <= 0) {
          return;
        }
        if (timer) {
          window.clearInterval(timer);
        }
        timer = window.setInterval(function () {
          setActive(current + 1);
        }, autoplayDelay);
      }

      setActive(0);
      if (!useFade) {
        updateTransforms();
      }
      updateHeight();
      restartAutoplay();

      container.setAttribute('data-mk-swiper-inited', 'true');
    }

    function initAllMkSwipers(root) {
      var scope = root || document;
      var containers = scope.querySelectorAll('.swiper.mk-slideshow');
      for (var i = 0; i < containers.length; i++) {
        initMkSwiper(containers[i]);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAllMkSwipers(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAllMkSwipers(event.target);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
      initAllMkSwipers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
